import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const ContactSupport = lazyRouteComponent(() => import('@/_instructor/contact-support'));

export const Route = createFileRoute('/_instructor/support/')({
  component: () => renderInstructorPage(ContactSupport),
});
